import * as React from 'react';
import { cn } from './lib/utils';
import { useTheme } from '../../contexts/ThemeContext';
import NNDonutChart from '../shared/NNDonutChart';

/**
 * Thin wrapper around shared/NNDonutChart that:
 * - Accepts a `className` for layout control
 * - Swaps the arc track colour in dark mode
 * - Provides a default colour from the NexoNurse brand if none given
 */
function NNDonutChartWidget({ value, total, color, size, className, ...props }) {
  const theme = useTheme();
  const resolvedColor = color ?? 'var(--aqua)';

  return (
    <div className={cn('inline-flex items-center justify-center', className)}>
      <NNDonutChart
        value={value}
        total={total}
        color={resolvedColor}
        size={size}
        darkMode={theme === 'dark'}
        {...props}
      />
    </div>
  );
}

export { NNDonutChartWidget };
